import React from "react";

const LoadingSpinner = ({ className = "" }) => {
  return (
    <div className={`spinner-container ${className}`.trim()}>
      <span className="loader"></span>
    </div>
  );
};

export default LoadingSpinner;
